/**
 * manpower/useManpower/openCalendars.js - the calendars open in this tab and
 * the closed ones still holding unsaved changes (module state shared by every
 * useManpower in the tab). Moved out of useManpower.js, which re-exports
 * forgetClosedCalendars.
 */

// The calendars open in this tab, each as its re-read. src/live never hands a
// tab its own saves back, so a calendar whose save lands tells the others
// here itself - the one just closed can still be saving as the next one opens.
const openCalendars = new Set();

// Calendars closed in this tab before all their changes were saved. One that
// had the server's copy keeps trying on its own; the next calendar opened here
// takes the changes over (takeOver), shows them and sends them with its own.
// A closed one would otherwise be the only place they were, and it shows no one.
const closedWithChanges = new Set();

/** Forget every closed calendar's unsaved changes and stop its retries. For tests, between tests. */
export function forgetClosedCalendars() {
  for (const c of [...closedWithChanges]) c.takeOver();
}

export { openCalendars, closedWithChanges };
